import { type UTCalendarUIContext, type UTPlaceReservationOriginType, type UTCalendarOrigin, type UTDeskReservationOrigin } from "@outlook/unified_telemetry";

export function convertPlaceOriginToCalendarContext(entryPoint: UTPlaceReservationOriginType | undefined): {
    context: UTCalendarUIContext;
    origin?: UTCalendarOrigin;
} {
    switch (entryPoint) {
        case "DeskBookingCompose":
            return {
                context: "FullComposeEventForm",
            };
        case "GlobalActionButton":
            return {
                context: "SearchBoxSuggestionsPanel",
            };
        case "ExploreQuickActionPill":
            return {
                context: "QuickActionCard",
            };
        case "ExploreAgendaViewAddRoom":
        case "ExploreAgendaViewBookDesk":
        case "AgendaSuggestions":
            return {
                context: "AgendaView",
            };
        case "DailyPeekDeskBooking":
        case "DailyPeekQuickBook":
            return {
                context: "WorkPlanDailyPeek",
            };
        default:
            return {
                context: "Other",
            };
    }
}

export function convertDeskOriginToCalendarContext(entryPoint: UTDeskReservationOrigin | undefined): {
    context: UTCalendarUIContext;
    origin?: UTCalendarOrigin;
} {
    switch (entryPoint) {
        case "CalendarRibbonNewButton":
            return {
                context: "AppRibbon",
            };
        case "DailyPeekQuickBook":
            return {
                context: "WorkPlanDailyPeek",
                origin: "BuildingListItem",
            };
        case "CalendarSurfaceItemContextMenu":
            return {
                context: "CalendarSurface",
                origin: "SurfaceItemContextMenu",
            };
        case "CalendarSurfaceItemClick":
            return {
                context: "CalendarSurface",
                origin: "SurfaceEventItem",
            };
        case "RetryLink":
            return {
                context: "NotificationPane",
            };
        case "FullComposeEdit":
            return {
                context: "ItemPeekEventForm",
            };
        case "PeekEdit":
            return {
                context: "WorkPlanDailyPeek",
                origin: "DeskListItem",
            };
        // not used in any codes
        case "DailyPeekBookNow":
        case "CalendarSurfaceContextMenu":
        case "ReadPaneEdit":
        case "CalendarSurfaceDragDrop":
        case "DeepLink":
        default:
            return {
                context: "Other",
            };
    }
}
